import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ReportsService } from "../reports.service";
import { LocalStorage } from "@ngx-pwa/local-storage";
import { FormBuilder, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { StadiumService } from "src/app/stadium/stadium.service";
import { UsersService } from "src/app/users/users.service";

declare var $: any;

@Component({
    selector: "app-edit-schedule",
    templateUrl: "./edit-schedule.component.html",
    styleUrls: ["./edit-schedule.component.scss"],
})
export class EditScheduleComponent implements OnInit {
    public fixture: any = null;
    public stadiums: any = null;
    public scheduleData: any = null;
    public sportsCategories: any = null;
    public users: any = null;
    public sportTypesTemp = null;
    public sportTypes = [
        { value: 7, name: "แข่งแบบพบกันหมด" },
        { value: 1, name: "รอบคัดเลือก (ทั่วไป)" },
        { value: 6, name: "รอบ 16 ทีมสุดท้าย" },
        { value: 2, name: "รอบ 8 ทีมสุดท้าย" },
        { value: 3, name: "รอบรอง (4 ทีมสุดท้าย)" },
        { value: 8, name: "รอบรอง (4 ทีมสุดท้ายแบบชิงที่สามร่วม)" },
        { value: 4, name: "ชิงเหรียญทองแดง" },
        { value: 5, name: "ชิงเหรียญทอง" },
    ];

    public timePeriods = [];

    constructor(
        private activetedRoute: ActivatedRoute,
        private localStorage: LocalStorage,
        private spinner: NgxSpinnerService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private reportsService: ReportsService,
        private stadiumService: StadiumService,
        private usersService: UsersService,
        private router: Router
    ) {
        this.spinner.show();
        this.timePeriods = this.generateTimePeriods(4, 22);
        this.activetedRoute.params.subscribe((params) => {
            this.getFixture(params.id);
            this.localStorage.getItem("user").subscribe((data) => {
                if (data !== null) {
                    this.getStadium();
                }

                this.usersService.getUsers().subscribe((res) => {
                    this.users = res;

                    setTimeout(() => {
                        this.datePicker();
                        this.selectTwo(false);
                        this.selectEvent(".time-select", "time");
                        this.selectEvent(".stadium-select", "stadium_id");
                        this.spinner.hide();
                    }, 500);
                });
            });
        });
    }

    ngOnInit() {}

    populateUserFields(value: any): void {
        value.users.forEach((user, index) => {
            const controlName = `user${this.convertNumberToWord(index + 1)}`;
            if (this.scheduleData.controls[controlName]) {
                this.scheduleData.controls[controlName].setValue(user.user_id);
            }
        });
    }

    convertNumberToWord(number: number): string {
        const words = [
            "One",
            "Two",
            "Three",
            "Four",
            "Five",
            "Six",
            "Seven",
            "Eight",
            "Nine",
            "Ten",
            "Eleven",
            "Twelth",
            "Thirten",
            "Fourteen",
            "Fifteen",
            "Sixteen",
            "Seventeen",
            "Eigthteen",
            "Nineteen",
            "Twenty",
            "TwentyOne",
            "TwentyTwo",
            "TwentyThree",
            "TwentyFour",
            "TwentyFive",
            "TwentySix",
            "TwentySeven",
            "TwentyEigth",
            "TwentyNine",
            "Thirty",
        ];
        return words[number - 1];
    }

    generateTimePeriods(
        startHour: number,
        endHour: number
    ): { value: string; name: string }[] {
        const timePeriods: { value: string; name: string }[] = [];
        const startTime = new Date();
        startTime.setHours(startHour, 0, 0, 0); // Start at specified hour

        const endTime = new Date();
        endTime.setHours(endHour, 0, 0, 0); // End at specified hour

        while (startTime <= endTime) {
            const hours = startTime.getHours().toString().padStart(2, "0");
            const minutes = startTime.getMinutes().toString().padStart(2, "0");
            const timeString = `${hours}:${minutes}:00`;
            timePeriods.push({
                value: timeString,
                name: `${hours}:${minutes}`,
            });
            startTime.setMinutes(startTime.getMinutes() + 5); // Increment by 5 minutes
        }

        return timePeriods;
    }

    getStadium() {
        this.stadiumService.getAll().subscribe((res) => {
            this.stadiums = res.result;
        });
    }

    getFixture(id: number) {
        this.reportsService.getFixtureById(id).subscribe((res) => {
            this.fixture = res.result;
            this.prepareForm(res.result);
        });
    }

    sportNameChange(value) {
        if (value === "") {
            this.scheduleData.controls.category_id.disable();
            this.sportsCategories = [
                {
                    id: "",
                    name: "กรุณาเลือก",
                    age_group_description: "ประเภทการแข่งขัน",
                },
            ];
            return;
        }
    }

    prepareForm(value: any) {
        // const usersVaule = `${value.users[0].id},${value.users[1].id}`
        this.scheduleData = this.formBuilder.group({
            sport_id: [{ value: value.category.sport_name, disabled: true }],
            category_id: [{ value: value.category.name, disabled: true }],
            type_id: [value.type_id, Validators.required],
            date: [value.date, Validators.required],
            time: [value.time, Validators.required],
            name: [value.name],
            stadium_id: [value.stadium_id, Validators.required],
            group: [value.group === "null" ? "" : value.group],
            users: [""],
            userOne: [""],
            userTwo: [""],
            userThree: [""],
            userFour: [""],
            userFive: [""],
            userSix: [""],
            userSeven: [""],
            userEight: [""],
            userNine: [""],
            userTen: [""],
            userEleven: [""],
            userTwelth: [""],
            userThirten: [""],
            userFourteen: [""],
            userFifteen: [""],
            userSixteen: [""],
            userSeventeen: [""],
            userEigthteen: [""],
            userNineteen: [""],
            userTwenty: [""],
            userTwentyOne: [""],
            userTwentyTwo: [""],
            userTwentyThree: [""],
            userTwentyFour: [""],
            userTwentyFive: [""],
            userTwentySix: [""],
            userTwentySeven: [""],
            userTwentyEigth: [""],
            userTwentyNine: [""],
            userThirty: [""],
        });

        this.sportTypesTemp = this.sportTypes.filter(
            (sportType) => sportType.value === value.type_id
        );

        this.populateUserFields(value);
    }

    datePicker() {
        const datePicker = $(".fc-datepicker").datepicker({
            dateFormat: "yy-mm-dd",
            showOtherMonths: false,
            selectOtherMonths: false,
            minDate: "2025-01-16",
            maxDate: "2025-01-25",
            yearRange: "2025:2025",
            dayNamesMin: ["จ", "อ", "พ", "พฤ", "ศ", "ส", "อา"],
            hideIfNoPrevNext: true,
            onSelect: (dateText: any) => {
                this.scheduleData.controls.date.setValue(dateText);
            },
        });

        datePicker.datepicker("setDate", this.fixture.date);
    }

    selectTwo(isClear: boolean) {
        if (isClear) {
            $('[class*="select2-show-search]"').val(null).trigger("change");
            return false;
        }

        const selectElements: any = document.querySelectorAll(
            '[class*="select2-show-search"]'
        );

        for (let i = 0; i < selectElements.length; i++) {
            const className = `.select2-show-search-user${i + 1}`;
            const formControlName =
                selectElements[i].getAttribute("formControlName");

            this.selectEvent(className, formControlName);
        }
    }

    selectEvent(element: string, formControlName: string) {
        const options = { minimumResultsForSearch: "" };
        const $selectElement = $(element).select2(options);

        $selectElement.on("select2:select", (e: any) => {
            this.scheduleData.controls[formControlName].setValue(
                e.params.data.id
            );
        });
    }

    scheduleDataSubmit(value: any) {
        this.spinner.show();
        let fixesData = {
            id: this.fixture.id,
            type_id: value.type_id,
            date: value.date,
            time: value.time,
            name: value.name,
            stadium_id: value.stadium_id,
            group: value.group === null ? "" : value.group,
            users: value.users,
        };

        if (value.userOne !== "" && value.userTwo !== "") {
            fixesData.users = `${value.userOne},${value.userTwo},${value.userThree},${value.userFour},${value.userFive},${value.userSix},${value.userSeven},${value.userEight},${value.userNine},${value.userTen},${value.userEleven},${value.userTwelth},${value.userThirten},${value.userFourteen},${value.userFifteen},${value.userSixteen},${value.userSeventeen},${value.userEigthteen},${value.userNineteen},${value.userTwenty},${value.userTwentyOne},${value.userTwentyTwo},${value.userTwentyThree},${value.userTwentyFour},${value.userTwentyFive},${value.userTwentySix},${value.userTwentySeven},${value.userTwentyEigth},${value.userTwentyNine},${value.userThirty}`;
        }

        this.reportsService.edit(fixesData).subscribe((res) => {
            if (res.result) {
                this.toastr.success(`แก้ไขรายการแข่งสำเร็จ`, "Success");
                const redirectUrl = `/report/schedule-sport-overview/${this.fixture.category.sport_id}/${this.fixture.category_id}/${this.fixture.category.sport_name}`;
                this.router.navigate([redirectUrl]);
            }

            this.spinner.hide();
        });
    }
}
